<div>

	<div class="rowScreenColPhone">

		<div></div>

		<mat-spinner diameter=30 *ngIf="bLoading"></mat-spinner>

		<button
			mat-raised-button
			color="primary"
			[disabled]="bLoading"
			(click)="showCreationDialog()"
		>
			Neue Gruppe
		</button>

	</div>

	<div>

		@if( !elements.length ) {
			@if( !bLoading ) {
				<div class="accNoElements">
					Keine Gruppen vorhanden
				</div>
			}
		}
		@else {

			<div class="accFilterAndAccordeon">

				<mat-form-field
					appearance="outline"
					subscriptSizing="dynamic"
					class="accFilter"
				>

					<mat-label>Filter</mat-label>
					<input
						matInput
						placeholder="Beispiel: gruppe1"
						(keyup)="onFilterChanged($event)"
					>
					<mat-icon matSuffix>search</mat-icon>

				</mat-form-field>

				<div
					class="accAccordeon"
					[style.--nbColumns]="'2'"
				>

					@if( !filteredElements.length ) {

						<div class="accNoElements">
							Keine Daten entspricht dem Filter
						</div>

					}	
					@else {

						<div
							class="accHeaders"
							[class.accSortIconDesc]="!sortingAsc"
						>

							<div
								class="accCell"
								[class.accActiveSorting]="sortingField == 'gruppenname'"
								(click)="sortColumn('gruppenname')"
								title="Nach Name sortieren"
							>
								<div class="accHeader">
									<span>Name</span>
									<mat-icon class="accSortIcon">
										{{ sortingField == 'gruppenname' ? 'arrow_downward' : 'swap_vert' }}
									</mat-icon>
								</div>
							</div>

							<div
								class="accCell"
								[class.accActiveSorting]="sortingField == 'gruppeBeshreibung'"
								(click)="sortColumn('gruppeBeshreibung')"
								title="Nach Beschreibung sortieren"
							>
								<div class="accHeader">
									<span>Beschreibung</span>
									<mat-icon class="accSortIcon">
										{{ sortingField == 'gruppeBeshreibung' ? 'arrow_downward' : 'swap_vert' }}
									</mat-icon>
								</div>
							</div>

						</div>
							
						<div class="accScrollPanel">

							@for( element of filteredElements; track element.gruppenname ) {

								<div
									class="accRow"
									(click)="clickOnRow( element.gruppenname )"
									[class.accRowActive]="expandedElementId == element.gruppenname"
									[id]="'elementRow_' + element.gruppenname"
								>
									<div class="accCell">
										{{ element.gruppenname }}
									</div>
									<div class="accCell">
										{{ element.gruppeBeshreibung }}
									</div>
								</div>

								@if( expandedElementId == element.gruppenname ) {

									<div
										class="accDetail"
										[@accordeonMe]
									>
										<app-file-group-editor
											[group]="element"
											[allFolders]="folders"
										/>
									</div>

								}

							}

						</div>

					}

				</div>

			</div>

		}

	</div>

</div>
